export class AllocationCalendarSlotPosition {
  top: number;
  height: number;
  column?: number = 1;

  constructor(params: AllocationCalendarSlotPosition) {
    Object.assign(this, params);
  }
}
